// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_WwE","cls2":"SearchOnboardingOverhaul-cls2_zuX SearchOnboardingOverhaul-cls1_WwE","leftAlign":"SearchOnboardingOverhaul-leftAlign_r2s"};